import { BooleanField } from "@/components/admin/boolean-field";
import { DataTable } from "@/components/admin/data-table";
import { List } from "@/components/admin/list";

export const FormationList = () => (
  <List
    title="Catalogue des formations"
    sort={{ field: "titre", order: "ASC" }}
  >
    <DataTable>
      <DataTable.Col source="reference" label="Réf." />
      <DataTable.Col source="titre" label="Intitulé" />
      <DataTable.Col source="duree_heures" label="Heures" />
      <DataTable.Col
        source="tarif_ht"
        label="Tarif HT par groupe de 1 à 4 (€)"
      />
      <DataTable.Col source="actif" label="Actif" field={BooleanField} />
    </DataTable>
  </List>
);
